module.exports = __webpack_public_path__ + "static/img/product_banner_45_zh.794af6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_banner_45_zh.png
// module id = m/xT
// module chunks = 34